import React from "react";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

const Logout = () => {
  const APP_PATH = process.env.REACT_APP_CONTEXT_PATH;
  const navigate = useNavigate();
  localStorage.removeItem("token");
  localStorage.clear();

  useEffect(() => {
    navigate((window.location.href = APP_PATH + "/"));
  }, []);

  return <section />;
};

export default Logout;
